import { render } from "./InstantEmailPage.vue?vue&type=template&id=593f3dd2&ts=true"
import script from "./InstantEmailPage.ts?vue&type=script&lang=ts&external"
export * from "./InstantEmailPage.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__